import { all, fork } from 'redux-saga/effects';

// function* invokeCreateTaskSimple(action: types.ICreateTaskSimple) {
//   yield call(services.createTaskSimple, action.payload);
// }
// function* invokeUpdateTaskSimple(action: types.IUpdateTaskSimple) {
//   yield call(services.updateTaskSimple, action.payload.id, action.payload.data);
// }

// function* invokeDeleteTaskSimple(action: types.IDeleteTaskSimple) {
//   yield call(services.deleteTaskSimple, action.payload);
// }

export function* watchMeetingTasksPurePageSaga() {
  // yield takeLatest(constants.CREATE_TASK_SIMPLE, invokeCreateTaskSimple);
  // yield takeLatest(constants.UPDATE_TASK_SIMPLE, invokeUpdateTaskSimple);
  // yield takeLatest(constants.DELETE_TASK_SIMPLE, invokeDeleteTaskSimple);
  //yield takeEvery(constants.SAVE_CHART_SOCKET, invokeSaveChartSocket);
}

export function* watchMeetingTasksPageStorageSaga() {
  yield all([watchMeetingTasksPurePageSaga].map(fork));
}
